/*
  Legend · selector de variantes (25-oct-2026)

  Turbo 9.5 solo cambia la opcion pulsada. Si esa combinacion no existe (Etna: 500W con la
  bateria de 36V) se queda en "No disponible" y el cliente no sabe que tiene que tocar la bateria.
  Este fichero:
    1. Si la combinacion no existe, salta a la variante mas parecida que si existe: mantiene lo
       pulsado, prefiere una disponible, cambia el menor numero de opciones y, a igualdad, las
       ultimas antes que las primeras (antes la bateria que el color).
    2. Oculta los valores que no se pueden elegir con lo ya seleccionado (no existen o estan
       agotados) y los vuelve a ensenar cuando se pueden elegir. Los colores no se ocultan:
       siguen tachados como hasta ahora. Tampoco se oculta nada si el producto entero esta agotado.

  Se carga desde layout/theme.liquid justo despues de app.js. Si se actualiza Turbo, volver a
  anadir esa linea: el resto del tema no se ha tocado.
*/
(function () {
  var ultimo = null; // { form, indice } de la ultima opcion que ha tocado el cliente
  var ES_COLOR = /colou?r|couleur|\bcor\b|kleur|farbe|kolor/i;

  function apuntar(e) {
    var swatch = e.target && e.target.closest && e.target.closest('.swatch[data-option-index]');
    if (swatch) {
      ultimo = { form: swatch.closest('.product_form'), indice: parseInt(swatch.getAttribute('data-option-index'), 10) };
    }
  }
  document.addEventListener('click', apuntar, true);
  document.addEventListener('change', apuntar, true);

  function selectores(form) {
    return form.querySelectorAll('.single-option-selector');
  }

  function valoresActuales(form) {
    return Array.prototype.map.call(selectores(form), function (s) { return s.value; });
  }

  // Menor es mejor: [no disponible, opciones cambiadas, peso de las cambiadas]
  function puntuacion(v, actual, indice) {
    var cambios = 0, peso = 0, n = v.options.length;
    for (var i = 0; i < n; i++) {
      if (i !== indice && v.options[i] !== actual[i]) { cambios++; peso += n - i; }
    }
    return [v.available ? 0 : 1, cambios, peso];
  }

  function mejorVariante(product, actual, indice) {
    var mejor = null, mejorP = null;
    product.variants.forEach(function (v) {
      if (v.options[indice] !== actual[indice]) return;
      var p = puntuacion(v, actual, indice);
      for (var i = 0; i < p.length; i++) {
        if (mejorP && p[i] > mejorP[i]) return;
        if (!mejorP || p[i] < mejorP[i]) { mejor = v; mejorP = p; return; }
      }
    });
    return mejor;
  }

  function aplicar(form, variante) {
    var sels = selectores(form);
    variante.options.forEach(function (valor, i) { if (sels[i]) sels[i].value = valor; });
    window.jQuery(sels[0]).trigger('change');
  }

  function ocultarNoSeleccionables(form, product, actual) {
    // Producto agotado entero (etna-kit): se ensena todo tachado, como hasta ahora
    if (!product.variants.some(function (v) { return v.available; })) return;
    form.querySelectorAll('.swatch[data-option-index]').forEach(function (swatch) {
      var k = parseInt(swatch.getAttribute('data-option-index'), 10);
      var titulo = (swatch.querySelector('.option_title') || {}).textContent || '';
      var elementos = swatch.querySelectorAll('.swatch-element');
      if (!elementos.length || elementos[0].classList.contains('color') || ES_COLOR.test(titulo)) return;
      elementos.forEach(function (el) {
        var valor = String(el.getAttribute('data-value'));
        var elegible = valor === actual[k] || product.variants.some(function (v) {
          if (!v.available || v.options[k] !== valor) return false;
          for (var j = 0; j < k; j++) if (v.options[j] !== actual[j]) return false;
          return true;
        });
        el.style.display = elegible ? '' : 'none';
      });
    });
  }

  function envolver() {
    var original = window.selectCallback;
    if (typeof original !== 'function' || original.legend) return;
    // Antes de llamar a Turbo: con variante null su selectCallback lanza una excepcion
    // (updateGallery lee variant.featured_media) y no se llegaria a corregir nada.
    var envuelta = function (variant, selector) {
      var form = null;
      try {
        var campo = selector && selector.variantIdField;
        form = campo && campo.closest('.product_form');
        if (form && (!form.querySelector('.swatch_options') || !window.jQuery)) form = null;
        if (form && !variant && ultimo && ultimo.form === form) {
          var v = mejorVariante(selector.product, valoresActuales(form), ultimo.indice);
          ultimo = null;
          if (v) { aplicar(form, v); return; }
        }
      } catch (e) {
        if (window.console) console.warn('legend-variant-fallback', e);
      }
      original.apply(this, arguments);
      try {
        if (form) ocultarNoSeleccionables(form, selector.product, variant ? variant.options : valoresActuales(form));
      } catch (e) {
        if (window.console) console.warn('legend-variant-fallback', e);
      }
    };
    envuelta.legend = true;
    window.selectCallback = envuelta;
  }

  envolver();
  document.addEventListener('DOMContentLoaded', envolver);
})();
